import axios from "axios";

/**
 * Axios instance with pre-configured settings for the Malayan API.
 * @typedef {Object} AxiosInstance
 */
const notifAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_NOTIFICATION_MANAGEMENT_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

notifAxiosInstance.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("notifIdToken");

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default notifAxiosInstance;
